import { jwtDecode, JwtPayload } from "jwt-decode";

interface IJwtPayload extends JwtPayload {
  [key: string]: any;
}

interface IDecodedAccessToken {
  ipaddr: string;
  oid: string;
  appid: string;
  tid: string;
  wids: string[];
  exp: number;
}

class AccessTokenService {
  private _accessToken: string = "";
  private _decodedAccessToken: IDecodedAccessToken = {
    ipaddr: "",
    oid: "adm-user",
    appid: "",
    tid: "",
    wids: [],
    exp: 0,
  };

  set accessToken(accessToken: string) {
    const decodedCurrentToken = this.decodeAccessToken(accessToken);
    const decodeExistingToken = this.decodeAccessToken(this._accessToken);
    if (
      !this._accessToken ||
      decodedCurrentToken?.exp > decodeExistingToken.exp
    ) {
      this._accessToken = accessToken;
    }
  }
  get accessToken() {
    return this._accessToken;
  }
  get decodedAccessToken(): IDecodedAccessToken {
    return this._decodedAccessToken;
  }

  decodeAccessToken = (accessToken: string) => {
    try {
      const { ipaddr, appid, tid, oid, exp, wids } =
        jwtDecode<IJwtPayload>(accessToken);
      const decodedAccessToken = {
        ipaddr,
        oid,
        appid,
        tid,
        wids,
        exp: exp as number,
      };
      this._decodedAccessToken = decodedAccessToken;
      return this._decodedAccessToken;
    } catch (e) {
      console.error("Error decoding access token:", e);
      return this._decodedAccessToken;
    }
  };
}

export const accessTokenService = new AccessTokenService();
export default accessTokenService;
